import { useMsal, useIsAuthenticated } from '@azure/msal-react';
import { useCallback } from 'react';
import { loginRequest, apiRequest } from '../config/authConfig';

export function useAuth() {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();

  const login = useCallback(async () => {
    try {
      await instance.loginPopup(loginRequest);
    } catch (error) {
      console.error('Login failed:', error);
      throw error;
    }
  }, [instance]);

  const logout = useCallback(async () => {
    try {
      await instance.logoutPopup();
    } catch (error) {
      console.error('Logout failed:', error);
      throw error;
    }
  }, [instance]);

  const getAccessToken = useCallback(async (): Promise<string | null> => {
    const account = accounts[0];
    if (!account) return null;

    try {
      const response = await instance.acquireTokenSilent({
        ...apiRequest,
        account,
      });
      return response.accessToken;
    } catch (error) {
      console.error('Failed to acquire token silently:', error);
      try {
        const response = await instance.acquireTokenPopup(apiRequest);
        return response.accessToken;
      } catch (popupError) {
        console.error('Failed to acquire token via popup:', popupError);
        return null;
      }
    }
  }, [instance, accounts]);

  const account = accounts[0] || null;

  const user = account
    ? {
        id: account.localAccountId,
        email: account.username,
        name: account.name || account.username,
      }
    : null;

  return {
    isAuthenticated,
    user,
    login,
    logout,
    account,
    getAccessToken,
  };
}
